export default __webpack_public_path__ + "static/media/scheduling-video-posts-with-kontentino.ce7c7fe9.svg";